import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type WhatsappConfigurationAppEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const whatsappConfigurationAppEntryPoint: EntryPoint<
	WhatsappConfigurationAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<WhatsappConfigurationAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-messaging-apps-whatsapp-app" */ './WhatsappConfigurationApp.tsx',
	),
	getPreloadProps: () => ({}),
});
